<div
  class="AddLabelsNotesModal"
  [ngClass]="{ 'AddLabelsNotesModal--hidden': !addingLabelsNotes }"
>
  <div class="AddLabelsNotesModal__Mask" (click)="cancel()"></div>
  <ng-container body>
    <section class="AddLabelsNotesModal__Section">
      <div class="AddLabelsNotesModal__Content">
        <div class="AddLabelsNotesModal__ButtonsWrapper">
          <zip-button
            class="AddLabelsNotesModal__Button"
            (click)="handleAddLabels()"
            [config]="{
              level: 'text',
              content: 'Add Labels',
              size: 'fullWidth'
            }"
          ></zip-button>
          <zip-button
            class="AddLabelsNotesModal__Button"
            (click)="handleAddNotes()"
            [config]="{
              level: 'text',
              content: 'Add Notes',
              size: 'fullWidth'
            }"
          ></zip-button>
        </div>

        <div class="AddLabelsNotesModal__ButtonsWrapper">
          <zip-button
            class="AddLabelsNotesModal__Button"
            (click)="cancel()"
            [config]="{ level: 'text', content: 'Cancel', size: 'fullWidth' }"
          ></zip-button>
        </div>
      </div>
    </section>
  </ng-container>
</div>
